module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ma-ab052b412792b9fadd8c6a53bf717d63.svg";